import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { PageLayoutAdmin, PageLayoutExternal } from './component';
import { Admin, Map, NotFound, MapEmbed } from './pages';

import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { configService } from './service';
import { Typography } from '@mui/material';

const App = ({ pca }) => {
    const signInLoading = () => {
        return <Typography>Please wait. We are trying to sign you in.</Typography>;
    };

    const signInError = () => {
        return <Typography>We encountered an error while trying to sign you in.</Typography>;
    };

    return (
        <MsalProvider instance={pca}>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<PageLayoutExternal />}>
                        <Route index element={<Map />} />
                    </Route>

                    <Route path="/embed" element={<MapEmbed />} />

                    <Route path="/admin" element={<PageLayoutAdmin />}>
                        <Route
                            index
                            element={
                                <MsalAuthenticationTemplate
                                    interactionType={InteractionType.Redirect}
                                    authenticationRequest={configService.azureAdMsal.scope.scopes}
                                    loadingComponent={signInLoading}
                                    errorComponent={signInError}
                                >
                                    <Admin />
                                </MsalAuthenticationTemplate>
                            }
                        />
                    </Route>

                    <Route path="*" element={<NotFound />} />
                </Routes>
            </BrowserRouter>
        </MsalProvider>
    );
};

export default App;
